import { useSyncExternalStore } from "react";

const LEAD = "nbs_lead_email";
const NAME = "nbs_lead_name";
const PLAYED = "nbs_video_played";
const listeners = new Set();

const read = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const write = (k, v) => { try { localStorage.setItem(k, v); } catch { /* private mode */ } };

let state = { email: read(LEAD), name: read(NAME), played: read(PLAYED) === "1" };
const emit = () => listeners.forEach((l) => l());

export const viewer = {
  get email() { return state.email; },
  setLead(email, name) { write(LEAD, email); write(NAME, name); state = { ...state, email, name }; emit(); },
  setPlayed() { if (state.played) return; write(PLAYED, "1"); state = { ...state, played: true }; emit(); },
  requestPlay() { window.dispatchEvent(new Event("nbs:play")); },
};

const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };
export const useViewer = () => useSyncExternalStore(subscribe, () => state);
